import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, filter, take } from 'rxjs/operators';
import { FeatureFlagService } from './feature-flag.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagGuard implements CanActivate {
    private featureFlagService = inject(FeatureFlagService);

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const feature = route.data['requiredFeature'] as string;
        if (!feature) {
            return of(true);
        }
        return this.featureFlagService.flags$.pipe(
            filter((flags) => flags.length > 0),
            take(1),
            map(() => this.featureFlagService.isFeatureVisible(feature)())
        );
    }
}
